module.exports = __webpack_public_path__ + "static/media/56.fe7fb206.jpg";